// Canonical brand term for Swoop's human sales team (Luke, 2026-06-10).
// Working value pending Luke's emailed final wording — change HERE only.
export const SPECIALIST_TERM = "Swoop Planning Specialists";
export const SPECIALIST_TERM_SINGULAR = "Swoop Planning Specialist";
export const SPECIALIST_TERM_RE = /swoop(?:'s)? planning specialists?/i;
